import type {
  ContactRequestBody,
  Translation,
} from 'store/slices/general/general.slice';
import { endpoints } from 'store/endpoints';
import type { User } from 'types/users';
import type { GetTranslationsQuery } from 'store/slices/general/actions';
import { downloadFromBlob } from 'common/helpers/downloadFromBlob';
import { axiosInstance } from './axiosInstance';

export class GeneralService {
  static async downloadTranslations() {
    try {
      const response = await axiosInstance.get(endpoints.translations.export, {
        responseType: 'blob',
      });
      downloadFromBlob(response.data, 'translations.xlsx');
    } catch (error: any) {
      throw new Error(error);
    }
  }
  static async sendMailToSupport(payload: ContactRequestBody) {
    try {
      await axiosInstance.post(endpoints['contact-us'].general, payload);
    } catch (err: any) {
      throw new Error(err);
    }
  }
  static async getSupportEmails() {
    try {
      const response = await axiosInstance.get<Array<User>>(
        endpoints['contact-us'].supports,
      );
      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }
  static async getAllTranslations(
    params: Partial<GetTranslationsQuery>,
    forceIgnoreQuery?: boolean,
  ) {
    try {
      const response = await axiosInstance.get(endpoints.translations.general, {
        params: {
          ...(!forceIgnoreQuery && {
            ...params,
            page: params.page || 1,
            pageSize: params.pageSize || 50,
          }),
        },
      });
      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }

  static async createNewTranslation(payload: Omit<Translation, 'id'>) {
    try {
      const response = await axiosInstance.post(
        endpoints.translations.general,
        payload,
      );
      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }

  static async updateTranslation(payload: Translation) {
    try {
      const { id, ...rest } = payload;
      const response = await axiosInstance.patch(
        endpoints.translations.opWithId(id),
        rest,
      );
      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }
}
